
import './App.css';
import CalorieCalculator from "./CalorieCalculator";

function App() {
  return (
    <div>
      <CalorieCalculator/>
    </div>
  );
}

export default App;
